import { jsxs, jsx } from "react/jsx-runtime";
const IconSpaceRoomSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M2.786 1.393C2.786.623 3.41 0 4.179 0h15.048c.77 0 1.393.624 1.393 1.393v20.552H2.786V1.393Zm1.393 0v19.159h15.048V1.393H4.18Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.572 4.179c0-.77.623-1.393 1.393-1.393h9.75c.77 0 1.393.624 1.393 1.393V21.59H5.572V4.179Zm11.143 0h-9.75v16.019h9.75V4.178Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M0 21.59c0-.384.312-.696.696-.696h22.607a.696.696 0 1 1 0 1.393H.697A.696.696 0 0 1 0 21.591ZM8.244 9.422c.288 0 .522.234.522.523V12a.522.522 0 1 1-1.045 0V9.945c0-.289.234-.523.523-.523Z"
        }
      )
    ]
  }
);
export {
  IconSpaceRoomSvg
};
